<script>
    let defaultHref = "#0";

    export default {
        props: {
            disabled: Boolean,
            text: String,
            nostyle: Boolean,
            loading: Boolean,
            fullWidth: Boolean,
            newWindow: Boolean,
            underline: Boolean,
            href: {
                type: String,
                default: defaultHref
            },
            target: {
                type: String,
                default: "_self",
                validator: value => ["_blank", "_self"].indexOf(value) !== -1
            }
        },
        data() {
            return {
                linkTarget: this.target,
                isHovered: false
            }
        },
        mounted() {
            if (this.target === "_self") {
                this.setTarget(this.newWindow);
            }
        },
        watch: {
            newWindow(val) {
                this.setTarget(val);
            }
        },
        methods: {
            click(e) {
                if (!this.disabled && !this.loading && this.href === defaultHref) {
                    if (this.linkTarget === "_blank") {
                        window.open(this.href);
                    } else {
                        window.location.href = this.href;
                    }
                    this.$emit("click", e);
                }
            },
            focus() {
                setTimeout(() => this.$refs.button.focus());
            },
            setTarget(newWindow) {
                if (newWindow) {
                    this.linkTarget = "_blank";
                } else {
                    this.linkTarget = "_self";
                }
            }
        }
    }
</script>

<template>
    <a ref="button" :disabled="disabled" :class="{ underline: underline, nostyle: nostyle, 'full-width': fullWidth, loading: loading, disabled: disabled }"
       :href="href" :target="linkTarget" @click="click" @keydown.enter.space="click">
        {{text}}
        <slot></slot>
    </a>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    a {
        cursor: pointer;
        width: auto;
        display: inline-block;

        &.underline {
            text-decoration: underline;
        }

        &.nostyle {
            text-decoration: none;
        }

        &:not(.nostyle) {
            color: @frontier-green;
        }

        &.disabled {
            opacity: .5;
            pointer-events: none;
        }

        &:hover {
            color: @ibe-text-blue;
        }
    }

</style>